module.exports = __webpack_public_path__ + "img/Hover_Merchant_on_Record.d8e4f3fd.png";